


import { defineComponent, onMounted, ref, onBeforeUnmount, onUnmounted, computed } from 'vue';
import { MessageService } from '../../../../../../../common/infrastructure/servicios';
import { MessageType } from '../../../../../../../common/infrastructure/servicios/MessageService';
import { IapComponentDataSource } from '../../../../../component/domain/iapComponentDataSource';
import ComponentCommon from '../../../../domain/Functions/ComponentCommon';
import TextAreaTypeConst from '../../../../domain/Constants/TextAreaTypeConst';
import { Container } from 'inversify';
import BaseControlTypeConst from '../../../../domain/Constants/BaseControlTypeConst';
import WidgetComponentDataTree from '../../../../../designer/domain/widgetComponent';
import { IapComponentAttribute } from '../../../../../component/domain/iapComponentAttribute';
import { IapCatalogType } from '../../../../../catalog/domain/iapCatalogType';
import CustomValidate from '../../shared/CustomValidate.vue';
import Mic from '../../../../../../../common/infrastructure/componentes/base/common/mic/Mic.vue';
import HelperCommon from '../../../../../../../common/infrastructure/funciones/HelperCommon';
import { Dictionary } from '../../../../../expression/domain/dictionary';
import { useStore } from 'vuex';

export default defineComponent({
    name: 'dynamic_text_area',
    components: {
        CustomValidate,
        Mic
    },
    props:
    {
        container: {
            type: Object as () => Container
        },
        Component: {
            type: Object as () => WidgetComponentDataTree,
            default: () => ({})
        },
        rootParentId:
        {
            type: Number,
            default: (-1)
        },
        dataSources: {
            type: Object as () => IapComponentDataSource[],
            default: () => ({})
        },
        slotProps: {
            type: Object,
            default: () => ({})
        },
        rootParentAttr: {
            type: Object as () => IapComponentAttribute[],
            default: () => ({})
        },

    },
    setup(props, context) {
        //
        const store = useStore();
        const { vmodel, loaded, resolveExpressions, getPropertyValue, getPropertyBooleanValue, getPropertyNumberValue, 
            baseOnUnmount, baseOnMounted, baseOnBeforeUnmount, v$, submitted, canEdit,isValidData
            ,fieldKey,fieldKeyComponentDataSourceId } = ComponentCommon(props, context,store);


        const clickf = ref(new Function());

        const clicktest = () => {
            // eval(' showMessage("click del boton"); alert("hola");')
        }
        const showMessage = (msg: string) => {
            MessageService.showToast(MessageType.Correcto, '', msg)
        }


        const hasGroupControls = computed(() => {
            return getPropertyBooleanValue(TextAreaTypeConst.MIC) || getPropertyBooleanValue(TextAreaTypeConst.COPYTOCLIPBOARDB)
        })

        onMounted(() => {

            baseOnMounted();

        })

        onBeforeUnmount(() => {

            baseOnBeforeUnmount();
        })


        onUnmounted(() => {

            baseOnUnmount();

        })




        return {
            clickf,
            MessageService,
            MessageType,
            showMessage,
            clicktest,
            getPropertyValue,
            getPropertyBooleanValue,
            vmodel,
            TextAreaTypeConst,
            getPropertyNumberValue,
            loaded,
            BaseControlTypeConst,
            v$,
            submitted,
            canEdit,
            hasGroupControls,
            HelperCommon,
            isValidData,
            fieldKey,
            fieldKeyComponentDataSourceId
        };
    },




});
